// Universal Quote (manual-quote) create flow — same endpoints and params as the Android technician app
// (UQConfigFragment). Every call resolves to { ok, body, paging, message, activeRecord } and never throws.
import { apiCall } from "./apiCall";

export const uqApi = {
  // trades (with service types + job types), property_types, payment_types, job_sources
  config: () => apiCall("get", "manual-quote/job-types/list"),
  // units of a consumer address ({ address_id }) or of the quote source ({ source_type, source_id })
  units: (params) => apiCall("get", "units/list", params),
  // adds / updates units at an address ({ address_id }) or a quote source ({ source_type, source_id }); the answer is the unit list
  saveUnits: (target, units) => apiCall("post", "units/update", { ...target, units: JSON.stringify(units) }),
  // phone → { appointment: [{ id }], service_and_repair: [{ id }], replacement_quote: [{ id }], consumer } (the sources a quote can come from)
  consumerResources: (phone) => apiCall("post", "manual-quote/get-consumer-resources", { phone }),
  // active-job check before creating (job_type "mq") → { count, items: [{ job_type }] }
  // the edit flow also sends the quote (job_id) and its visit_date (Android UQConfigFragment.checkTechValidate)
  validateTechnician: (extra = {}) => apiCall("post", "technicians/validate", { job_type: "mq", ...extra }),
  create: (params) => apiCall("post", "manual-quote/create", params),
  // Edit Quote of a normal quote (Android UQConfigFragment update mode): manual_quote_id + the same config fields
  update: (params) => apiCall("post", "manual-quote/update", params),
  addNote: (manualQuoteId, notes) => apiCall("post", "manual-quote/update-notes", { quote_id: manualQuoteId, notes }),
  // Quote detail header (Figma "Quote Details - Option 1"): the same read-only summary View Quote opens
  // (partner: manual-quote/partner/summary, else manual-quote/summary/calculate) → { item_total, total, items }.
  // Silent so the 45s detail refresh doesn't flash the loader.
  summary: (manualQuoteId, isPartner) => apiCall(
    "post",
    isPartner ? "manual-quote/partner/summary" : "manual-quote/summary/calculate",
    { manual_quote_id: manualQuoteId, status: "submitted" },
    { silent: true },
  ),

  // detail page (Android IndependentQuoteDetailFragment)
  qrCode: (manualQuoteId) => apiCall("get", "qrCode/job-detail", { job_id: manualQuoteId, job_source: "iq" }, { silent: true }),
  arrived: (manualQuoteId) => apiCall("post", "manual-quote/status/arrived", { manual_quote_id: manualQuoteId }),
  // all the quote's documents / photos (no is_before → before, after and other)
  documents: (manualQuoteId) => apiCall("get", "manual-quote/document/list", { manual_quote_id: manualQuoteId }, { silent: true }),
  uploadDocument: (manualQuoteId, file, title) => {
    const form = new FormData();
    form.append("manual_quote_id", manualQuoteId);
    form.append("document", file);
    if (title) form.append("title", title);
    return apiCall("post", "manual-quote/document/upload", form);
  },
  // axios.delete(url, config): send the ids as query params
  removeDocument: (manualQuoteId, id) => apiCall("delete", "manual-quote/document/remove", { params: { manual_quote_id: manualQuoteId, id } }),
};
